import { Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { replaceZerosWithHyphen } from 'Utils/replaceZerosWithHyphen';

interface ILinkedAppliedNumbers {
  appliedNumbers: string[];
}

export const LinkedAppliedNumbers = ({
  appliedNumbers,
}: ILinkedAppliedNumbers) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.PaymentsDeductions
  ).paymentDeductionCard;
  const isDesktop = useIsDesktop();

  return (
    <>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        justifyContent='space-between'
        sx={{
          mt: isDesktop ? '12px' : '24px',
        }}
      >
        <Stack
          direction='row'
          gap='6px'
          sx={{
            width: isDesktop ? 'fit-content' : '290px',
          }}
        >
          {appliedNumbers.length === 1 ? (
            <Typography variant='body6'>
              {dictionary.refferalApply}{' '}
              <Link
                href={`applies/${appliedNumbers[0]}`}
                sx={{
                  textDecoration: 'none',
                  color: 'primary.blue',
                  ':hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                {replaceZerosWithHyphen(appliedNumbers[0])}
              </Link>
            </Typography>
          ) : (
            <Stack>
              <Typography variant='body6'>
                {dictionary.regardingYourApplies} {dictionary.fromAppliedLobby}:
              </Typography>
              <Stack direction='row'>
                {appliedNumbers.map((number: string, index: number) => {
                  return (
                    <Typography key={index} variant='body6'>
                      {index > 0 ? ' , ' : ''}
                      <Link
                        href={`applies/${number}`}
                        sx={{
                          textDecoration: 'none',
                          color: 'primary.blue',
                          ':hover': {
                            textDecoration: 'underline',
                          },
                        }}
                      >
                        {replaceZerosWithHyphen(number)}
                      </Link>
                    </Typography>
                  );
                })}
              </Stack>
            </Stack>
          )}
        </Stack>
      </Stack>
    </>
  );
};
